<template>
  <div id="app">
    <v-app>
      <router-view />
    </v-app>
  </div>
</template>

<script>
import api from "@/api";
import { httpErrorHandler } from "@/utils/errors";

export default {
  name: "App",
  created() {
    api.interceptors.response.use(
      response => response,
      httpErrorHandler.bind(this)
    );
  }
};
</script>
